var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeach(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13.6924051px",
    height: "13.250001px",
    viewBox: "0 0 13.6924051 13.250001",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Large/Beach") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hotelcard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ThemaBadge/Round/Beach",
    transform: "translate(-9.254264, -9.249999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Large/Beach",
    transform: "translate(4.004240, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.5815,11.6995 C17.8215,11.362 18.29025,11.283 18.6275,11.52375 C18.96475,11.764 19.0435,12.23225 18.8035,12.5695 L16.574,15.69975 L17.84675,18.5 L16.199,18.5 L15.51725,17 L7.733,17 L7.05125,18.5 L5.4035,18.5 L6.76725,15.5 L14.87475,15.5 Z M11.06225,9.95125 L13.18325,14.5 L12.07975,14.5 L10.15525,10.373 C10.28025,10.262 10.42125,10.1675 10.57725,10.09475 C10.7325,10.02225 10.896,9.97525 11.06225,9.95125 Z M8.56975,5.78975 C10.969,4.671 13.7445,5.3515 15.3795,7.2755 C14.85425,7.19025 14.29875,7.25625 13.78,7.498 C13.06475,7.8315 12.563,8.43425 12.3335,9.1285 C11.654,8.858 10.86975,8.855 10.15475,9.1885 C9.4395,9.522 8.93775,10.12475 8.70825,10.819 C8.02875,10.5485 7.2445,10.5455 6.5295,10.879 C6.01075,11.12075 5.60325,11.504 5.33075,11.96125 C4.90775,9.47175 6.1705,6.9085 8.56975,5.78975 Z",
    id: "Combined-Shape",
    fill: "#2800A0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeach);
export default __webpack_public_path__ + "static/media/Beach.51e77b8daddd5be1a7fbb02bf12a8d94.svg";
export { ForwardRef as ReactComponent };